import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import HCExporting from 'highcharts/modules/exporting'
import HCOfflineExport from 'highcharts/modules/offline-exporting'
import { useRef, useState } from 'react'

if (typeof Highcharts === 'object') {
  HCExporting(Highcharts)
  HCOfflineExport(Highcharts)
}

export const PieChart = ({
  chartRef,
  data,
  title,
  subtitle,
  exportTitle,
  seriesName
}) => {
  const updateFlag = useRef(true)
  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: 'pie',
      style: {
        fontFamily: 'CorporateS'
      },
      events: {
        render: function () {
          // TODO! Check if this is the right way to handle the fullscreen event...
          const chart = this
          if (chart.fullscreen.isOpen && updateFlag.current) {
            updateFlag.current = false
            setTimeout(
              () =>
                setChartOptions({
                  ...chartOptions,
                  legend: { floating: false, y: 0 }
                }),
              100
            )
            // updateFlag.current = true;
          } else if (!chart.fullscreen.isOpen && !updateFlag.current) {
            updateFlag.current = true
            setChartOptions({ ...chartOptions, legend: { floating: true } })
            /* chart.update({
                  legend: {
                    options: {floating: 'true'}
                  }
                }) */

            // updateFlag.current = true;
          }
        }
      }
    },
    // colors: colorArray ? colorArray : ['red'],
    credits: {
      enabled: false
    },
    title: {
      text: title,
      align: 'center'
    },
    subtitle: {
      text: subtitle,
      align: 'center'
    },
    tooltip: {
      headerFormat: '',
      pointFormat:
        '<span style="color:{point.color}">\u25cf</span> ' +
        '{point.name} ({point.percentage:.1f}%)'
    },
    accessibility: {
      announceNewData: {
        enabled: true
      },
      point: {
        valueSuffix: '%'
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        borderWidth: 2,
        cursor: 'pointer',
        innerSize: '60%',
        borderRadius: 8,
        dataLabels: {
          enabled: false
        }
      }
    },
    series: [
      {
        enableMouseTracking: true,
        showInLegend: true,
        animation: {
          duration: 2000
        },
        name: seriesName,
        data
      }
    ],
    legend: {
      title: {
        text: '',
        style: {
          fontSize: '12px',
          letterSpacing: '0.3px',
          color: '#0A1944',
          fontWeight: '500'
        }
      },
      itemStyle: {
        fontSize: '12px',
        letterSpacing: '0.25px',
        color: '#0A1944',
        fontWeight: '500'
      },
      labelFormatter: function () {
        return (
          this.name.split('|')[0] + ' (' + this.percentage.toFixed(1) + '%)'
        )
      },
      floating: false,
      useHTML: true,
      alignColumns: true,
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
      itemDistance: 11,
      itemMarginBottom: 1,
      itemMarginTop: 8
    },
    navigation: {
      buttonOptions: {
        enabled: false
      }
    },
    exporting: {
      filename: `${title} ${exportTitle.split(':')[0]}`, // e.g. Endergebnis der Umfrage März 2025
      fallbackToExportServer: false,
      chartOptions: {
        title: {
          text: exportTitle
        }
      }
    }
  })

  const afterChartCreated = function (chart) {
    if (!chartRef.current) {
      chartRef.current = chart
    }
  }

  return (
    <div>
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        callback={afterChartCreated}
      />
    </div>
  )
}
